import React, { useEffect, useState } from 'react';

const PremiumNotFound = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [count, setCount] = useState(10);
  
  useEffect(() => {
    // Animation effect on load
    setTimeout(() => setIsLoaded(true), 100);
    
    // Countdown timer for redirect
    const timer = count > 0 && setInterval(() => setCount(count - 1), 1000);
    return () => clearInterval(timer);
  }, [count]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4 font-sans pt-[10rem] pb-10">
      <div className={`w-full max-w-4xl transition-all duration-1000 transform ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
        <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
          {/* Top accent line */}
          <div className="h-1 w-full bg-gradient-to-r from-orange-400 via-orange-500 to-orange-600"></div>
          
          <div className="grid md:grid-cols-2">
            {/* Left column - Image */}
            <div className="relative h-64 md:h-full">
              <img 
                src="https://images.unsplash.com/photo-1584824486509-112e4181ff6b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" 
                alt="404 Illustration" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                <div className="text-center p-6">
                  <h1 className="text-7xl md:text-8xl font-black text-white drop-shadow-lg">404</h1>
                  <div className="w-16 h-1 bg-orange-500 mx-auto my-4"></div>
                  <p className="text-white text-lg md:text-xl font-light">Page Not Found</p>
                </div>
              </div>
            </div>
            
            {/* Right column - Content */}
            <div className="p-8 md:p-12 flex flex-col justify-between">
              <div>
                <h2 className="text-3xl font-bold text-gray-800 mb-2">We've Lost This Page</h2>
                <div className="w-12 h-1 bg-orange-500 mb-6"></div>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  The page you are looking for might have been removed, had its name changed, 
                  or is temporarily unavailable. Please check the URL or navigate back to the homepage.
                </p>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-center">
                    <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7m-7-7v14" />
                      </svg>
                    </div>
                    <p className="text-gray-700">Return to our homepage</p>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <p className="text-gray-700">Contact our support team</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="flex flex-col sm:flex-row gap-4">
                  <a 
                    href="/" 
                    className="px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-medium rounded-lg shadow-lg hover:shadow-orange-500/30 transition-all duration-300 transform hover:-translate-y-1 text-center"
                  >
                    Back to Homepage
                  </a>
                  <button
                    onClick={() => window.history.back()}
                    className="px-6 py-3 bg-white text-gray-700 border border-gray-300 font-medium rounded-lg shadow-sm hover:bg-gray-50 transition-all duration-300 text-center"
                  >
                    Go Back
                  </button>
                </div>
                
                <p className="text-gray-500 text-sm">
                  Redirecting to homepage in <span className="text-orange-500 font-semibold">{count}</span> seconds...
                </p>
              </div>
            </div>
          </div>
          
          {/* Footer */}
          <div className="bg-gray-50 px-8 py-4 border-t border-gray-100">
            <div className="flex flex-col sm:flex-row justify-between items-center">
              <p className="text-gray-500 text-sm">
                © 2025 Rayane. All rights reserved.
              </p>
              <div className="flex space-x-4 mt-3 sm:mt-0">
                <a href="/privacy" className="text-gray-500 hover:text-orange-500 text-sm">Privacy Policy</a>
                <a href="/terms" className="text-gray-500 hover:text-orange-500 text-sm">Terms of Service</a>
                <a href="/help" className="text-gray-500 hover:text-orange-500 text-sm">Help Center</a>
              </div>
            </div>
          </div>
          
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500 opacity-5 rounded-full transform translate-x-16 -translate-y-16"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-orange-500 opacity-5 rounded-full transform -translate-x-16 translate-y-16"></div>
        </div>
      </div>
    </div>
  );
};

export default PremiumNotFound;
